import { Checkbox, Chip } from "components/commons";
import { prettifyStationStatus } from "utils/pretty.utils";
import StationStatusEnum from "enums/station-status";

export const mapDataToList = ({ station, onCheck, selected }) => {
  const { status, name, stationCode, region, island } = station;
  const renderStatus = () => {
    return (
      <>
        <div style={{ display: "flex", gap: "10px" }}>
          <Chip
            label={prettifyStationStatus(status)}
            status={
              {
                [StationStatusEnum.ACTIVE]: "success",
                [StationStatusEnum.PENDING]: "primary",
                [StationStatusEnum.DEACTIVATED]: "default",
                [StationStatusEnum.MANUAL_MODE]: "warning",
              }[status]
            }
            size="small"
            style={{ padding: "0px 5px" }}
          />
        </div>
      </>
    );
  };

  return {
    select: (
      <Checkbox
        name={name}
        value={selected?.includes(stationCode)}
        onChange={(name) => onCheck?.(stationCode)}
      />
    ),
    stationCode: stationCode,
    stationName: name,
    stationType: station?.type ?? "-",
    status: renderStatus(),
    region: region ?? "-",
    island: island ?? "-",
  };
};

export const mapFilterToRequest = (filterState) => {
  const { stationType, island, region, status, ...fs } = filterState;

  if (stationType?.value?.length > 0) {
    fs.type = stationType?.value?.join(",");
  }

  if (stationType?.isSelectedAll) {
    fs.type = undefined;
  }

  if (status?.value?.length > 0) {
    fs.status = status?.value?.join(",");
  }

  if (status?.isSelectedAll) {
    fs.status = undefined;
  }

  if (island?.value?.length > 0) {
    fs.island = island?.value?.join(",");
  }

  if (island?.isSelectedAll) {
    fs.island = undefined;
  }

  if (region?.value?.length > 0) {
    fs.region = region?.value?.join(",");
  }

  if (region?.isSelectedAll) {
    fs.region = undefined;
  }

  return fs;
};
